import Action from "./class.Action";

export default class SkipToChapter extends Action {
	/**
	 * Public Constructor
	 * @param {string[]} options
	 * @returns
	 */
	constructor(options) {
		super(options);

		// Get the data from the model
		const class_id = options.attributes.mainController.class_id;
		const user_id = options.attributes.mainController.user_id;
		const problemHash = this.getProblemHash(options);

		// Get chapter, converting any variables
		let chapter = options.model.chapter ? options.model.chapter : "";
		chapter = this.mainController.transporterVariables.processValue(chapter);

		// For debug mode we display a bubble, this won't show up in a real session
		if (options.attributes.playthrough_id === null) {
			this.renderDebugBubble(chapter, problemHash);
		} else {
			// Otherwise show modal asking if they want to skip unless this is a replay
			if (!AoPS.Transporter.isReplay) {
				this.showModal(class_id, user_id, chapter, problemHash, options);
			}
		}

		return this.onAdvance(this.$anchor);
	}

	/**
	 * Get problem hash in proper format
	 */
	getProblemHash(options) {
		let problemHash = "";

		let problem = options.model.problem ? options.model.problem : "";
		problem = this.mainController.transporterVariables.processValue(problem);

		if (problem !== "") {
			problemHash = problem.replace(" #", ":").toLowerCase();
		}

		return problemHash;
	}

	/**
	 * Open modal that asks if they want to skip or start from beginning
	 * @param {int}} class_id
	 * @param {int} user_id
	 * @param {int} chapter
	 * @param {string} problemHash
	 * @param {string[]} message
	 */
	showModal(class_id, user_id, chapter, problemHash, options) {
		const modalText = this.getModalText(options);

		const buttons = [
			{text: modalText.skipButton, value: "yes"},
			{text: modalText.continueButton, value: "no"},
		];
		const modalOptions = {
			max_width: "500px",
			title: modalText.title,
			closeX: false,
			force_response: "y",
		};
		AoPS.Ui.Modal.showButtonsQuick(
			modalText.message,
			buttons,
			(result) => {
				this.updateProgress(
					class_id,
					user_id,
					chapter,
					problemHash,
					result === "yes"
				);
			},
			modalOptions
		);
	}

	/**
	 * Get text for the modal
	 */
	getModalText(options) {
		const modalText = {};

		// Load the modal title and text
		let title = options.model.modal_title ? options.model.modal_title : "";
		modalText.title =
			this.mainController.transporterVariables.processValue(title);

		let message = options.model.modal_text ? options.model.modal_text : "";
		modalText.message =
			this.mainController.transporterVariables.processValue(message);

		let skipButton = options.model.skip_button ? options.model.skip_button : "";
		modalText.skipButton =
			this.mainController.transporterVariables.processValue(skipButton);

		let continueButton = options.model.continue_button
			? options.model.continue_button
			: "";
		modalText.continueButton =
			this.mainController.transporterVariables.processValue(continueButton);

		return modalText;
	}

	/**
	 * Send data to the server to update progress
	 */
	updateProgress(class_id, user_id, chapter, problemHash, skip = true) {
		$.ajax({
			url: "/m/class/ajax.php",
			timeout: 20000,
			type: "post",
			data: {
				a: "skip_to_chapter",
				class_id: class_id,
				user_id: user_id,
				chapter: chapter,
				problemHash: problemHash,
				skip: skip,
			},
			success: (data) => {
				if (data.error_msg) {
					AoPS.Ui.Modal.showAlertQuick(data.error_msg);
				} else {
					// If they want to skip, redirect to class homepage
					if (skip) {
						window.location = "/class/" + class_id;
					}
				}
			},
			error: () => {
				AoPS.Ui.Modal.showAlertQuick(
					"An unknown error occurred. Please refresh the page and try again."
				);
			},
		});
	}

	/**
	 * Display bubble in debug mode
	 */
	renderDebugBubble(chapter, problemHash) {
		let content = "";

		if (chapter) {
			content = "<em>Skip To Chapter:</em> " + chapter;
			if (problemHash !== "") {
				content += ": " + problemHash;
			}
		} else {
			content = "<em>ERROR:</em> Missing values";
		}

		const bubbleView = this.layoutView.placeBubble(
			this.$anchor,
			this.method,
			"center"
		);
		bubbleView.setContent(content);
	}
}
